// assistia-sdk/src/types/security.ts
/**
 * Structured security response for SDK calls.
 * Replaces the previous behaviour of throwing on HTTP errors.
 */
export var SecurityErrorType;
(function (SecurityErrorType) {
    SecurityErrorType["FORBIDDEN"] = "FORBIDDEN";
    SecurityErrorType["BLOCKED"] = "BLOCKED";
    SecurityErrorType["INVALID_PAYLOAD"] = "INVALID_PAYLOAD";
    SecurityErrorType["UNKNOWN"] = "UNKNOWN";
})(SecurityErrorType || (SecurityErrorType = {}));
//# sourceMappingURL=security.js.map